/*******************************************************************************
 * @ngdoc   component
 * @name    csm.books.MakeDeposit.component:amountRange
 * @module  makeDeposit
 * @param   {String}  label        Label for the row.
 * @param   {Object}  rangeObject  Object that contains the `from` and `to`
 *                                 properties.
 * @description
 * Creates two inputs in a horizontal row to use as a filter range. The two
 * values are stored in a single `rangeObject` to be manipulated by the inputs.
 *
 * TODO Remove the $ctrl.label and all bootstrap column classes. This should be
 * converted to a more generalized component that can take `from` and `to`
 * bindings, and requires a transcluded input field to be ng-repeated, or some
 * other way of using different inputs depending on use.
 *******************************************************************************/
export const dateRangeComponent = {
  bindings: { label: '@', rangeObject: '=' },
  template:
    '<div class="form-horizontal row">' +
    '<label class="col-md-3 control-label" ng-bind="$ctrl.label"></label>' +
    '<div class="col-md-4">' +
    '<date-input style="width:100%" ng-model="$ctrl.rangeObject.startDate"></date-input>' +
    '</div>' +
    '<label class="col-md-1 control-label">To</label>' +
    '<div class="col-md-4">' +
    '<date-input style="width:100%" ng-model="$ctrl.rangeObject.endDate"></date-input>' +
    '</div>' +
    '</div>',
  controller: Controller
}

/*******************************************************************************
 * @ngdoc    controller
 * @name     csm.books.MakeDeposit.Component.controller:Controller
 * @description
 * Initializes the rangeObject.
 *******************************************************************************/
/* @ngInject */ function Controller() {
  /** Self reference. */ var mThis = this;
  mThis.$onInit = function () {
    if (!mThis.rangeObject)
      mThis.rangeObject = { startDate: null, endDate: null };
  };
}
